module.exports = __webpack_public_path__ + "img/after4.94019d8c.jpg";